var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    [
      _c("toggle-button", {
        staticClass: "active-toggle",
        staticStyle: { "font-size": "12pt" },
        attrs: {
          value: _vm.isEnabled,
          color: "#82C7EB",
          sync: true,
          labels: { checked: "Enabled", unchecked: "Disabled" },
          width: 105,
          height: 33,
        },
        on: {
          change: function ($event) {
            return _vm.togglePackages($event.value)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "info-row",
        { staticClass: "info-main-row", attrs: { title: "Group Name" } },
        [
          _c("b-form-input", {
            staticClass: "input-info-field",
            attrs: {
              disabled: !_vm.isEnabled,
              id: "group-booking-name",
              type: "text",
              value: _vm.groupBookingName,
            },
            on: { update: _vm.update },
            model: {
              value: _vm.groupBookingName,
              callback: function ($$v) {
                _vm.groupBookingName = $$v
              },
              expression: "groupBookingName",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }